module.exports = __webpack_public_path__ + "static/media/sonder1.752db76b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/article/sonder1.jpg
// module id = 380
// module chunks = 0